// let resumeData = {
// 	"imagebaseurl":"http://localhost:3000/",
// 	"name": "César Augusto",
// 	"role": "Full Stack Developer e amante dos grafos",
// 	"roleDescription": "Um desenvolvedor de portais e sistemas web, além de um estudioso da teoria dos grafos e combinatória extremal.",
// 	"facebookUrl": "https://www.facebook.com/dm.cesaraugusto",
// 	"linkedinUrl": "https://www.linkedin.com/in/césar-augusto-dos-santos-bispo",
// 	"instagramUrl": "https://www.instagram.com/caezaraugustus/",
// 	"address": "136 Rua Agda Ferreira",
// 	"neighborhood":"São Marcos",
// 	"city": "Salvador",
// 	"state": "Bahia",
// 	"country": "Brasil",
// 	"unit": "BA",
// 	"initialsCountry": "BR",
// 	"tel": "(71) 99404-1379",
// 	"mail": "dm.cesaraugusto@gmail.com",
// 	"universityFormationGraduation": "Universidade Fedral da Bahia",
// 	"degree": "Bacharelando em Ciência da Computação",
// 	"courseDescription": "O curso de Ciência da Computação estuda o desenvolvimento de sistemas para as múltiplas plataformas e a construção de soluções computacionais para problemas da sociedade. O bacharel formado trabalha com as diversas etapas e abordagens do desenvolvimento de software e está preparado para resolver problemas reais, aplicando soluções que unam a teoria e a prática. Modelar bancos de dados, desenvolver e implementar projetos de software e propor soluções computacionais eficientes e econômicas são apenas algumas de suas atividades."

// }

let resumeData = {
  	"imagebaseurl":"https://cesaraugustobispo.github.io/",
	"name": "César Augusto",
	"role": "Full Stack Developer e amante dos grafos",
  	"linkedinId":"césar-augusto-dos-santos-bispo",
  	"githubId": "CesarAugustoBispo",
  	"facebookId": "dm.cesaraugusto",
  	"instagramId": "caezaraugustus",
  	"roleDescription": "Um desenvolvedor de portais e sistemas web, além de um estudioso da teoria dos grafos e combinatória extremal.",
  	"socialLinks":[
      	{
        	"name":"linkedin",
        	"url":"https://www.linkedin.com/césar-augusto-dos-santos-bispo",
        	"className":"fa fa-linkedin"
      	},
      	{
        	"name":"github",
        	"url":"http://github.com/CesarAugustoBispo",
        	"className":"fa fa-github"
      	},
      	{
        	"name":"facebook",
        	"url":"http://facebok.com/dm.cesaraugusto",
        	"className":"fa fa-facebook"
      	},
      	{
        	"name":"instagram",
        	"url":"http://instagram.com/caezaraugustus",
        	"className":"fa fa-instagram"
      	}
    ],
  	"aboutme":"Eu sou graduando em Ciência da Computação, com uma certa experiência no desenvolvimento de aplicações voltadas para o âmbito teatral, como o sistemas de bilheteria, e com sistemas de gerência de eventos. Acadêmicamente interessado por teória dos grafos e combinatória extremal sendo minha principal linha de estudo atualmente.",
  	"address": "136 Rua Agda Ferreira",
	"neighborhood":"São Marcos",
	"city": "Salvador",
	"state": "Bahia",
	"country": "Brasil",
	"unit": "BA",
	"initialsCountry": "BR",
	"tel": "(71) 99404-1379",
	"mail": "dm.cesaraugusto@gmail.com",
  	"education":[
    	{
      		"UniversityName":"Universidade Fedral da Bahia",
      		"specialization":"Bacharelando em Ciência da Computação",
      		"MonthOfPassing":"Jan",
      		"YearOfPassing":"2013",
      		"Achievements":"O curso de Ciência da Computação estuda o desenvolvimento de sistemas para as múltiplas plataformas e a construção de soluções computacionais para problemas da sociedade. O bacharel formado trabalha com as diversas etapas e abordagens do desenvolvimento de software e está preparado para resolver problemas reais, aplicando soluções que unam a teoria e a prática. Modelar bancos de dados, desenvolver e implementar projetos de software e propor soluções computacionais eficientes e econômicas são apenas algumas de suas atividades."
    	},
  	],
  	"work":[
    	{
	    	"CompanyName":"Sesc Bahia",
	      	"specialization":"Programador",
	      	"MonthOfLeaving":"Set",
	      	"YearOfLeaving":"2015",
	      	"Achievements":"Desenvolvimento do sistema de bilheteria dos teatros Sesc Bahia e desenvolvimento do sistema de recebimento, encaminhamento e gestão do fale conosco."
    	},
    	{
      		"CompanyName":"STI UFBA",
      		"specialization":"Programador",
      		"MonthOfLeaving":"Jan",
      		"YearOfLeaving":"2018",
      		"Achievements":"Desenvolvimento de novas funcionalidades e manutenção corretiva do sistema de gerência de eventos(GERE), além do atendimento para suporte da gestão dos eventos."
    	}
  	],
  	"skillsDescription":"Minhas especialidades",
  	"skills":[
    	{
      		"skillname":"HTML5"
    	},
    	{
      		"skillname":"CSS"
    	},
    	{
      		"skillname":"Reactjs"
    	},
    	{
      		"skillname":"jQuery"
    	},
    	{
      		"skillname":"Wordpress"
    	},
    	{
      		"skillname":"Python"
    	},
    	{
      		"skillname":"PHP"
    	}
  	],
  	"portfolio":[
    	{
      		"name":"Portal Senalba Bahia",
      		"description":"Portal desenvolvido para divulgação de notícias e informações pertinentes aos funcionários atendidos por este sindicato.",
      		"imgurl":"images/portfolio/senalbabahia.png",
          "url": "http://www.senalbabahia.com.br/",
          "id": "1"
    	},
    	{
      		"name":"Portal Sindsaude Bahia",
          "description":"Portal desenvolvido para divulgação de notícias e informações pertinentes aos funcionários atendidos por este sindicato.",
      		"imgurl":"images/portfolio/sindsaudeba.png",
      		"url":"https://sindsaudeba.org.br/portal/",
          "id": "2"
    	},
    	{
      		"name":"Portal Sindvigilantes Bahia",
          "description":"hPortal desenvolvido para divulgação de notícias e informações pertinentes aos funcionários atendidos por este sindicato.",
      		"imgurl":"images/portfolio/sindvigilantesba.png",
      		"url":"http://sindvigilantes.org.br/",
          "id": "3"
    	}
  	],
  	"testimonials":[
    	{
      		"description":"This is a sample testimonial",
      		"name":"Some technical guy"
    	},
    	{
      		"description":"This is a sample testimonial",
      		"name":"Some technical guy"
    	}
  	]
}

export default resumeData